import { Table } from "@mantine/core";

import { APPLICATION_LIMIT_DATA } from "@/components/model/user/_type";
import { H2, Text } from "@/components/ui/elements";

export function ApplicationLimitTable() {
  const applicationLimitRows = APPLICATION_LIMIT_DATA.map((data, i) => (
    <Table.Tr key={i}>
      <Table.Td>{data.points}</Table.Td>
      <Table.Td ta="center">{data.noHistory}</Table.Td>
      <Table.Td ta="center">{data.withHistory}</Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <H2>【応募件数制限】</H2>
      <Text mt={5}>
        累計勤務数が50回以上の場合は、応募件数制限から20件加算されます。
      </Text>
      <Table title="応募制限" withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th rowSpan={2}>持ち点</Table.Th>
            <Table.Th colSpan={2} ta="center">
              応募制限履歴
            </Table.Th>
          </Table.Tr>
          <Table.Tr>
            <Table.Th w={100} maw={100} ta="center">
              なし
            </Table.Th>
            <Table.Th w={100} maw={100} ta="center">
              あり
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{applicationLimitRows}</Table.Tbody>
      </Table>
      <Text c="dimmed">
        ＊ 一度に応募できる件数の上限です。
        <br />＊
        キャンセル率など利用状況によっては、上記の上限より少なくなる場合があります。
      </Text>
    </>
  );
}
